export { default as SelectedProductsSidebar } from './SelectedProductsSidebar';
